import type { SearchCountParams } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useFacilitiesCount = (params: SearchCountParams) => {
  const client = useGyymClient()

  return useGyymSWR([client.user.facilities.searchCount, params], {
    // Do not revalidate on focus
    revalidateOnFocus: false,
    // Global SWRConfig disables revalidateOnMount; this hook has no SSR
    // fallback data, so we must opt in to fetch on mount.
    revalidateOnMount: true,
  })
}
